import type { AdditionalSearchFilterGroups } from '@library/types/members';

export const MEMBER_ADDITIONAL_FILTERS: AdditionalSearchFilterGroups = [
  {
    groupName: 'Primary search',
    filters: [
      {
        name: 'memberId',
        placeholder: 'Search member ID or UUID'
      },
      {
        containerClassName: 'w-[calc(50%-0.5rem)]',
        name: 'firstName',
        placeholder: 'Search first name'
      },
      {
        containerClassName: 'w-[calc(50%-0.5rem)]',
        name: 'lastName',
        placeholder: 'Search last name'
      },
      {
        name: 'email',
        placeholder: 'Search email'
      }
    ]
  },
  {
    groupName: 'Date range search',
    filters: [
      {
        component: 'PrizepicksDatePicker',
        name: 'joinDate',
        placeholder: 'Select join date'
      },
      {
        component: 'DateOfBirthInput',
        name: 'dateOfBirth',
        placeholder: 'Search date of birth'
      }
    ]
  },
  {
    groupName: 'Location search',
    filters: [
      {
        name: 'address',
        placeholder: 'Search address'
      },
      {
        containerClassName: 'w-[calc(50%-0.5rem)]',
        name: 'state',
        placeholder: 'Search state code'
      },
      {
        containerClassName: 'w-[calc(50%-0.5rem)]',
        name: 'postalCode',
        placeholder: 'Search zip code'
      },
      {
        name: 'currentSignInIp',
        placeholder: 'Search current sign in IP address'
      },
      {
        name: 'lastSignInIp',
        placeholder: 'Search last sign in IP address'
      }
    ]
  },
  {
    groupName: 'Other search',
    filters: [
      {
        containerClassName: 'w-[calc(50%-0.5rem)]',
        name: 'referralCode',
        placeholder: 'Search referral code'
      },
      {
        containerClassName: 'w-[calc(50%-0.5rem)]',
        name: 'inviteCode',
        placeholder: 'Search invite code'
      },
      {
        name: 'pushNotificationToken',
        placeholder: 'Search push notification token'
      },
      {
        component: 'MemberEntriesFilter',
        name: 'numberOfEntries',
        placeholder: 'Search number of entries'
      }
    ]
  }
];
